import { ChangeEvent, ComponentPropsWithRef } from 'react';

export enum InputStates {
  Default = 'Default',
  Error = 'Error',
  Success = 'Success',
}

export interface InputProps extends ComponentPropsWithRef<'input'> {
  label: string;
  hideLabel?: boolean;
  id: string;
  value?: string;
  helpText?: string;
  subText?: string;
  state?: InputStates;
  characterLimit?: number;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  subTextClassName?: string;
}
